import { render, staticRenderFns } from "./SettingOptionUI.vue?vue&type=template&id=495f1a16&scoped=true&"
import script from "./SettingOptionUI.vue?vue&type=script&lang=ts&"
export * from "./SettingOptionUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f1a16",
  null
  
)

export default component.exports